"use client";
import { i as t } from "./useRenderElement-B8V3_e8R.mjs";
function r(e) {
  return t(19) ? e : e ? "true" : void 0;
}
export {
  r as i
};
